import mapboxgl, { type LngLatLike } from 'mapbox-gl';
import { createMapPopupElement, type MapPopupProps, renderMapPopupToString } from '@/components/molecules/MapPopup';

const DEFAULT_POPUP_CLASS = 'sw-map-popup';

const DEFAULT_POPUP_OPTIONS: mapboxgl.PopupOptions = {
  closeButton: false,
  offset: 16,
  maxWidth: '360px',
  closeOnClick: false,
  className: DEFAULT_POPUP_CLASS,
};

export interface SetMapPopupContentOptions {
  useDom?: boolean;
}

export function getMapPopupHtml(props: MapPopupProps): string {
  return renderMapPopupToString(props);
}

export function setMapPopupContent(
  popup: mapboxgl.Popup,
  lngLat: LngLatLike,
  props: MapPopupProps,
  options?: SetMapPopupContentOptions,
): mapboxgl.Popup {
  if (options?.useDom) {
    popup.setDOMContent(createMapPopupElement(props));
  } else {
    popup.setHTML(getMapPopupHtml(props));
  }
  popup.setLngLat(lngLat);
  popup.setMaxWidth(DEFAULT_POPUP_OPTIONS.maxWidth ?? '360px');
  return popup;
}

export function createMapPopup(
  lngLat: LngLatLike,
  props: MapPopupProps,
  options?: mapboxgl.PopupOptions & SetMapPopupContentOptions,
): mapboxgl.Popup {
  const popup = new mapboxgl.Popup({
    ...DEFAULT_POPUP_OPTIONS,
    ...options,
    className: options?.className ? `${DEFAULT_POPUP_CLASS} ${options.className}` : DEFAULT_POPUP_OPTIONS.className,
  });

  return setMapPopupContent(popup, lngLat, props, options);
}

export function removeMapboxPopups(filter?: (element: Element) => boolean): void {
  const popups = document.getElementsByClassName('mapboxgl-popup');
  Array.from(popups).forEach((popup) => {
    if (!filter || filter(popup)) {
      popup.remove();
    }
  });
}
